export default class VendorErrorEntity {
    fieldName: string;
    errorDescription: string;
    public constructor (fieldName: string,errorDescription: string){
        this.fieldName = fieldName;
        this.errorDescription = errorDescription;
    }
}